/**
 * Opens a document in a new browser tab for viewing/downloading.
 *
 * The user can right-click → "Save As" to download the file.
 * A second presigned URL with Content-Disposition: attachment
 * may be added later if direct download is needed.
 *
 * See: document-review-card.gts for the same pattern.
 */
export default function downloadDocument(downloadUrl: string, _title: string): void {
  window.open(downloadUrl, '_blank', 'noopener,noreferrer');
}
